var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Taras/Local Sites/nec/app/public/wp-content/themes/nec/node_modules/isarray/index.js
// module id = 260
// module chunks = 0